import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const OwnerIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 47.876 45.506">
      <path
        id="Path_113"
        data-name="Path 113"
        d="M47.072,32.893l-4.045-3.685V16.988A1.408,1.408,0,0,0,41.62,15.58H31.884a1.408,1.408,0,0,0-1.408,1.408v.783L25.592,13.32a2.444,2.444,0,0,0-3.307,0L.8,32.893a2.455,2.455,0,0,0,1.654,4.27H5.889V56.773A1.408,1.408,0,0,0,7.3,58.181H19.07a1.408,1.408,0,0,0,1.408-1.408V44.866H27.4V56.773a1.408,1.408,0,0,0,1.408,1.408H40.579a1.408,1.408,0,0,0,1.408-1.408V37.163h3.431a2.455,2.455,0,0,0,1.654-4.27Zm-6.493,1.454a1.408,1.408,0,0,0-1.408,1.408V55.365H30.214V43.458a1.408,1.408,0,0,0-1.408-1.408H19.07a1.408,1.408,0,0,0-1.408,1.408V55.365H8.7V35.755A1.408,1.408,0,0,0,7.3,34.347H3.389L23.938,15.623l7,6.376a1.408,1.408,0,0,0,2.356-1.041V18.4h6.92V29.829a1.408,1.408,0,0,0,.46,1.041l3.815,3.477H40.579Z"
        transform="translate(0 -12.676)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
    </SvgIcon>
  );
};
